import { Icon } from '@iconify/react';
import {
  Box,
  Chip,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
} from '@mui/material';
import { FC, MouseEvent, PropsWithChildren, ReactNode, useState } from 'react';
import { Link } from 'react-router-dom';

export interface Props extends PropsWithChildren {
  primary?: ReactNode;
  secondary?: ReactNode;
  to?: string;
  icon?: string;
  actions?: string[];
  onClick?: (...args: any[]) => void;
  labels?: ReactNode[];
}

const ICON_SIZE = 40;

export const Item: FC<Props> = ({ primary, secondary, labels, id, children, to, icon, actions, onClick, ...props }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const innerOnClick = (action: string, id: string) => {
    handleClose();
    onClick?.(action, id);
  };

  const open = Boolean(anchorEl);
  const Wrapper = to
    ? ListItemButton
    : (props) => (
        <Box
          {...props}
          sx={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between' }}
        />
      );

  return (
    <ListItem
      disableGutters
      {...props}
      secondaryAction={
        !actions?.length ? null : (
          <>
            <IconButton aria-label="comment" onClick={handleClick}>
              <Icon icon="mi:options-vertical" width="24" height="24" />
            </IconButton>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
            >
              {actions?.map((action, i) => (
                <MenuItem key={i} onClick={() => innerOnClick(action, id)}>
                  {action}
                </MenuItem>
              ))}
            </Menu>
          </>
        )
      }
    >
      <Wrapper component={to ? Link : undefined} to={to}>
        {icon && (
          <ListItemAvatar>
            <Icon icon={icon} width={ICON_SIZE} height={ICON_SIZE} />
          </ListItemAvatar>
        )}

        <ListItemText secondary={secondary}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            {primary || children}
            {labels && (
              <>
                {labels?.map((label, i) => (
                  <Chip key={i} size="small" variant="outlined" sx={{ marginTop: 1 }} label={label} />
                ))}
              </>
            )}
          </Box>
        </ListItemText>
      </Wrapper>
    </ListItem>
  );
};

export default Item;
